"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative min-h-screen w-full overflow-hidden">
      {}
      <div className="fixed inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1477031/img/consulting_strategy_meeting.png)",
      backgroundAttachment: "fixed"
    }} />

      {}
      <div className="fixed inset-0 bg-dark-background/60" />

      {}
      <div className="relative z-10 mx-auto flex min-h-screen max-w-7xl items-center px-6 py-16 lg:px-8">
        <div className="grid w-full gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={leftRef} className={`flex flex-col justify-center space-y-6 transition-all duration-300 ease-out ${leftVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
            <h1 className="text-4xl font-semibold leading-tight text-foreground-dark lg:text-5xl xl:text-6xl">
              Transform Your Business with Expert Guidance
            </h1>
            <p className="text-lg leading-relaxed text-foreground-dark/90 lg:text-xl">
              Navigate operational challenges, strengthen financial management,
              and develop strategic plans for sustainable growth.
            </p>
            <p className="text-base leading-relaxed text-foreground-dark/80">
              RESTORE AND HOPE LLC provides customized consulting and
              non-accredited educational services to help small and mid-size
              enterprises achieve their full potential.
            </p>
          </div>

          {}
          <div ref={rightRef} className={`flex items-center justify-center lg:justify-end transition-all duration-300 ease-out ${rightVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
            <Button asChild size="lg" className="transform rounded-lg bg-accent px-8 py-6 text-lg font-semibold text-foreground-accent shadow-medium transition-all duration-150 ease-in-out hover:scale-102 hover:bg-accent-hover focus-visible:ring-accent/40">
              <Link to="/ContactPage">Start Your Journey</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}